export default __webpack_public_path__ + "static/media/US_INFO_COM.9c7a1c8e.png";